import {
  agePrint,
  separateDateTime,
  capitalizeFirstLetter,
  getPatientIdForDoctor,
} from '../../../utils/helpers';
import { Row, Col } from 'react-bootstrap';
import profileImg from '../../../assets/images/profile.svg';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useGetRequest } from '../../../hooks/useGetRequest';
import { usePostRequest } from '../../../hooks/usePostRequest';
import AddPatientInfo from '../modals/addPatientInfo';
import { useValidation } from '../../../hooks/validationHooks/useValiation';
import { appointmentSchema } from '../../../validationSchemas/appointment.validation';
import { toast } from 'react-toastify';

const PatientHistoryLeft = ({
  patientData,
  prescriptions,
  generalExamination,
  lastOnExamination,
  lastAppointment,
  lastPrescriptionId,
}) => {
  console.log('lastOnExamination: ', lastOnExamination);
  const [imageContent, setImageContent] = useState('');
  // for patient edit modal
  const [phoneNumber, setPhoneNumber] = useState('');
  const [backendError, setBackendError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOnExamination, setSelectedOnExamination] = useState({});

  const [patientPicture, setPatientPicture] = useState(null);
  const [patientInfo, setPatientInfo] = useState({});
  const [patientId, setPatientId] = useState('');
  const [isOpenCamera, setIsOpenCamera] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [errors, setErrors] = useState({});
  const [loadingStatus, setLoadingStatus] = useState(false);

  const [appointmentInfo, setAppointmentInfo] = useState({});
  const [appointmentDateTime, setAppointmentDateTime] = useState('');
  const [visitType, setVisitType] = useState('new');
  const [visitationFee, setVisitationFee] = useState('');
  const [patientType, setPatientType] = useState('new');
  const [generalExaminationNew, setGeneralExaminationNew] = useState({});
  const [infoModal, setInfoModal] = useState(false);

  const validation = useValidation;

  const userInfo = useSelector((state) => state.authReducer.data);
  const activeOrganization = useSelector(
    (state) => state.orgReducer.organization,
  );
  const activeDoctor = useSelector(
    (state) => state.doctorsOfAssistantReducer.activeDoctor,
  );
  //end of patient edit modal

  const patientSettings = useSelector(
    (state) => state?.prescriptionReducer?.prescriptionInfo?.patientSettings,
  );
  const ageProperties = patientSettings?.items?.find(
    (item) => item.name === 'age',
  );
  let { unitProperties } = ageProperties || {};

  const countTotalItems = () => {
    return prescriptions?.reduce(
      (total, data) => {
        total.chiefComplain += data?.chiefComplains?.length || 0;
        total.diagnosis += data?.diagnoses?.length || 0;
        total.investigation += data?.investigations?.length || 0;
        total.advice += data?.advices?.length || 0;
        total.medicine += data?.medicines?.length || 0;
        total.followUp += data?.followUps?.length || 0;
        return total;
      },
      {
        chiefComplain: 0,
        diagnosis: 0,
        investigation: 0,
        advice: 0,
        medicine: 0,
        followUp: 0,
      },
    );
  };

  const { isLoading: isGetImageLoading, refetch: getImageLoad } = useGetRequest(
    `getSignatureContent-${patientData.id}`,
    `auth-patient/patient-profile-picture-for-doctor/${patientData.id}`,
    (data) => {
      setImageContent(data);
    },
    (e) => {
      console.log(e);
    },
  );

  useEffect(() => {
    console.log('lastOnExamination: ', lastOnExamination);
    countTotalItems();
    getImageLoad();
    setPatientInfo({ ...patientData });
    setSelectedOnExamination({ ...lastOnExamination });
    setAppointmentInfo({ ...lastAppointment });
  }, [lastOnExamination, patientData, lastAppointment]);

  const { isPatientLoading, mutate: submitUser } = usePostRequest(
    'prescriptions/update-patient-with-general-examination',
    {
      name: patientInfo.name,
      //dob: ageOrDob ? dob : ageConvertToDateTime(dob),
      dob: patientInfo.dob,
      phoneNumber: patientInfo.phoneNumber
        ? patientInfo.phoneNumber
        : phoneNumber,
      gender: patientInfo.gender ? patientInfo.gender : 'male',
      address: patientInfo?.patientDetails?.address,
      email: patientInfo?.email,
      appointmentDateTime: appointmentDateTime,
      visitType: visitType,
      serialNumber: patientInfo?.serialNumber,
      fee: parseInt(visitationFee),
      generalExaminations: selectedOnExamination?.generalExaminations,
      nid: patientInfo?.patientDetails?.nid,
      reference_by: patientInfo?.patientDetails?.reference_by,
      registration_no: patientInfo?.patientDetails?.registration_no,
      disease: patientInfo?.patientDetails?.disease,
      image: patientInfo?.image ? patientInfo?.image : null,
      doctorId: userInfo.id,
      patientId: patientInfo.id,
      appointmentId: appointmentInfo.id,
      prescriptionId: lastPrescriptionId,
      organizationId: activeOrganization.id,
      patientType: patientType,
    },
    (data) => {
      toast.success(data.message, {
        position: toast.POSITION.TOP_RIGHT,
      });
    },
    (error) => {
      setLoadingStatus(false);
      setBackendError(error.message);
    },
  );

  const handleSubmit = () => {
    console.log('working on fucntion....');
    setLoadingStatus(true);
    const { isValid, errors } = validation(
      {
        ...patientInfo,
        birthDate: patientInfo?.dob,
        appointmentDateTime: '2025-05-05 5:30 am', //as placeholder, no meaning of appointment date time
      },
      appointmentSchema,
    );
    if (isValid) {
      console.log('scucess submit');
      console.log('data detais; ', selectedOnExamination?.generalExaminations);
      submitUser();
    }
    {
      if (Object?.keys(errors)?.length !== 0) {
        setErrors(errors);
        setLoadingStatus(false);
      }
    }
  };

  return (
    <>
      <div className="text-center">
        <div
          className="edit-patient-link"
          onClick={() => setInfoModal(!infoModal)}
        >
          <i className="fa fa-user-edit" /> Edit
        </div>
        {imageContent === '' || isGetImageLoading ? (
          <img
            className="patient-img rounded-circle"
            src={profileImg}
            alt="profile image"
          />
        ) : (
          <img
            src={imageContent}
            className="patient-img rounded-circle"
            alt="profile image"
          />
        )}
        <div className="patient-name">{patientData?.name}</div>
        <div className="patient-phone-number">{patientData?.phoneNumber}</div>
        <div className="patient-email light-blue-color">
          {patientData?.email}
        </div>
        <div className="patient-pid">
          Patient ID:{' '}
          {getPatientIdForDoctor(patientData?.patientIdForDoctor, userInfo)}
        </div>
      </div>
      <hr className="mb-0" />
      <Row>
        <Col className="m-2">
          <Row className="summary-box">
            <Col>
              <div className="pt-1">Gender</div>
              <div className="pt-1 font-weight-bold">
                {capitalizeFirstLetter(patientData?.gender)}
              </div>
            </Col>
            <Col>
              <div className="pt-1">Age</div>
              <div className="pt-1 font-weight-bold">
                {agePrint(separateDateTime(patientData?.dob), unitProperties)}
              </div>
            </Col>
          </Row>
          <Row className="summary-box">
            <Col>
              <div className="pt-1">Height</div>
              <div className="pt-1 font-weight-bold">
                {generalExaminationNew?.heightInfo?.feet}
                {generalExaminationNew?.heightInfo?.inch
                  ? '.' + generalExaminationNew?.heightInfo?.inch
                  : ''}{' '}
                {generalExaminationNew?.heightInfo?.heightUnit}
              </div>
            </Col>
            <Col>
              <div className="pt-1">Weight</div>
              <div className="pt-1 font-weight-bold">
                {generalExaminationNew?.weightInfo?.weight}{' '}
                {generalExaminationNew?.weightInfo?.weightUnit}
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="m-1 summary-box">
        <Col>
          <div className="pt-1">Total Appointments</div>
          <div style={{ fontSize: '24px' }}>{prescriptions?.length}</div>
        </Col>
      </Row>
      <Row>
        <Col className="ml-1 mr-1 mb-1">
          <div className="text-center font-weight-bold">
            Summary of prescriptions
          </div>
          <Row className="summary-box">
            <Col>
              <div className="value">{countTotalItems()?.chiefComplain}</div>
              <div className="item">Chief Complain</div>
            </Col>
            <Col>
              <div className="value">{countTotalItems()?.diagnosis}</div>
              <div className="item">Diagnosis</div>
            </Col>
            <Col>
              <div className="value">{countTotalItems()?.medicine}</div>
              <div className="item">Rx</div>
            </Col>
          </Row>
          <Row className="summary-box">
            <Col>
              <div className="value">{countTotalItems()?.followUp}</div>
              <div className="item">Follow Up</div>
            </Col>
            <Col>
              <div className="value">{countTotalItems()?.investigation}</div>
              <div className="item">Investigation</div>
            </Col>
            <Col>
              <div className="value">{countTotalItems()?.advice}</div>
              <div className="item">Advice</div>
            </Col>
          </Row>
        </Col>
      </Row>

      <AddPatientInfo
        patientPicture={imageContent}
        patientInfo={patientInfo}
        setPatientInfo={setPatientInfo}
        infoModal={infoModal}
        setInfoModal={setInfoModal}
        appointmentInfo={appointmentInfo}
        setAppointmentInfo={setAppointmentInfo}
        selectedOnExamination={selectedOnExamination}
        setSelectedOnExamination={setSelectedOnExamination}
        fromPage="patientHistory"
        handleSubmit={handleSubmit}
      />
    </>
  );
};

export default PatientHistoryLeft;
